import { capitalize, lowerCase } from 'lodash';
import simpleSoilAttribute from './simpleSoilAttribute';

const depthToRestrictiveLayer = (restrictionKind?: string) =>
  simpleSoilAttribute({
    key: restrictionKind
      ? `Depth to Restrictive Layer (${restrictionKind})`
      : 'Depth to Any Restrictive Layer',
    ratingCol: {
      displayString: 'Depth (cm)',
      accessor: 'mapUnitRatingString',
    },
    ruleId: restrictionKind ? '50' : '309',
    shortFormData: {
      reskind: restrictionKind
        ? capitalize(lowerCase(restrictionKind))
        : undefined,
      TiebreakRule: '-1',
    },
    units: 'cm',
  });

export const DEPTH_TO_ANY_RESTRICTIVE_LAYER = depthToRestrictiveLayer();

export const DEPTH_TO_RESTRICTIVE_LAYER_DENSIC = depthToRestrictiveLayer(
  'Densic Material',
);

export const DEPTH_TO_RESTRICTIVE_LAYER_FRAGIPAN = depthToRestrictiveLayer(
  'Fragipan',
);
